export default {
  login: {
    login: "ログイン",
    email: "Eメール",
    mobile: "携帯電話",
    mobile2: "携帯電話番号",
    password: "パスワード",
    errMsg1: "メールアドレスを入力してください",
    errMsg2: "携帯電話番号を入力してください",
    errMsg3: "お客様のアカウントはこの地域で登録されていません",
    errMsg4: "ログインIDまたはパスワードが正しくありません",
    errMsg5: "携帯電話番号またはパスワードが正しくありません",
    errMsg6: "お支払いが確認できなかったため、登録手続きが完了しておりません。お手数ですが、登録フォームを再度ご提出のうえ、お支払いを完了してください。",
    forgotpw: "パスワードを忘れましたか？",
    register: "登録",
    txt: "インペリアル・トレジャー・クラブの会員登録はまだですか？インペリアル・トレジャー・クラブの ",
    txt_2: "会員特典内容をご覧ください。",
  },
  header: {
    home: "ホーム",
    eStore: "E-ストア",
    PRivileges: "会員特典",
    register: "登録",
    highlights: "ハイライト",
    faq: "よくあるご質問",
    mobileApp: "Mobile App",
    tnp: "ご利用規約およびプライバシーポリシー",
    friendReferral: "Friend Referral",
    profile: "プロフィール",
  },
  footer: {
    aboutUs: "当グループについて",
    eStore: "E-ストア",
    faq: "よくあるご質問",
    tnp: "ご利用規約およびプライバシーポリシー",
    pr: "プログラム参加レストラン",
    profile: "プロフィール",
    contactUs: "お問い合わせ",
    copyright: "Copyright © 2026 Imperial Treasure Restaurant Group Pte Ltd.",
  },
  signUp: {
    signUp: "会員登録",
    title: "インペリアル・トレジャー・クラブの会員登録をする",
    mustFill: '"※"は必須項目',
    step1: "アカウントの詳細",
    step2: "セキュリティ情報",
    step3: "購読",
    step4: "参照元",
    salutation: "敬称",
    salutation_opt1: "敬称を選択してください",
    salutation_opt2: "Mr",
    salutation_opt3: "Mrs",
    salutation_opt4: "Mdm",
    salutation_opt5: "Miss",
    salutation_opt6: "Dr",
    salutation_errMsg: "敬称を選択してください",
    firstname: "名",
    firstname_errMsg: "名を記入してください",
    lastname: "姓",
    lastname_errMsg: "姓を記入してください",
    birth: "生年月日",
    birth_errMsg: "生年月日を選択してください",
    birth_errMsg2: "18歳以上の方のみご利用可能です",
    mobile: "携帯電話番号",
    mobile_errMsg: "有効な携帯電話番号を入力してください",
    mobile_errMsg2: "この携帯電話番号はすでに登録されています。",
    emailAddress: "Eメールアドレス",
    emailAddress_errMsg: "有効なEメールアドレスを入力してください",
    emailAddress_errMsg2: "Eメールアドレスはすでに登録されています",
    confirmEmailAddress: "Eメールアドレスを確認する",
    confirmEmailAddress_errMsg: "Eメールアドレスを確認してください",
    gender: "性別",
    gender_opt1: "性別を選択してください",
    gender_opt2: "男性",
    gender_opt3: "女性",
    gender_errMsg: "性別を選択してください",
    language_preference: "ご希望の言語",
    language_preference_opt1: "ご希望の言語を選択してください",
    language_preference_opt2: "English",
    language_preference_opt3: "日本語",
    language_preference_opt4: "中文",
    language_preference_errMsg: "ご希望の言語を選択してください",
    password_format: "パスワードは、8文字以上の英数字からなり、少なくとも1つの大文字と1つの特殊文字（?!@$%&*）を含む必要があります。",
    password: "*パスワード",
    password_errMsg: "パスワードを入力してください",
    confirm_password: "*パスワードを確認する",
    confirm_password_errMsg: "パスワードを再入力してください",
    step3_consent_opt: "以下のすべての<link>利用規約<link>に同意します",
    step3_consent_opt_1: "私は<link>利用規約<link>に同意します",
    step3_consent_opt_2: "私は、私の個人情報の収集と使用に同意します",
    step3_consent_opt_3: "私は、マーケティングを目的とする私の個人情報の収集と使用に同意します",
    step3_consent_opt_4: "私は、日本国内または海外の第三者に私の個人情報を転送することに同意します ",
    tnc_errMsg: "Please agree to Terms & Conditions to proceed",
    step3_title: "下のボックスにチェックを入れる事で、私はインペリアル・トレジャー・グループPte Ltd（以降「ITRG」とする）に、私が提供した私の個人情報、またはインペリアル・トレジャー・クラブ会員の権利を私が利用する事に関わるデータ（以降「データ」とする）、あるいはその双方を、インペリアル・トレジャーがその関連会社あるいは第三者と共有する事を目的に、収集・使用・蓄積・開示のいずれかまたは全てを行うことを許可します。これにより私は、私の会員特権またはロイヤリティープログラムの特典を十分に楽しむことができ、そこにはインペリアル・トレジャーが持つシンガポール国外のサービス提供者との関係性により派生する特典も含まれるからです。",
    step3_q: "インペリアル・トレジャーからマーケティング関連のメッセージを受信する事に同意します(オプション)。",
    step3_q_opt1: "Eメール経由で",
    step3_q_opt2: "携帯電話経由で",
    step4_q_err: "当グループのプログラムについてどこでお知りになったのか選択してください。",
    step4_q: "当グループのプログラムについてどこでお知りになりましたか？",
    step4_q_opt1: "参照元を選択",
    step4_q_opt2: "東京都中央区銀座, インペリアル・トレジャー",
    step4_q_opt3: "Marina Bay Sands, Fine Chinese Cuisine",
    step4_q_opt4: "Paragon, Super Peking Duck",
    step4_q_opt5: "Asia Square, Super Peking Duck",
    step4_q_opt6: "ION Orchard, Fine Teochew Cuisine​",
    step4_q_opt7: "Marina Bay Sands, Fine Teochew Cuisine​",
    step4_q_opt8: "Takashimaya S.C, Fine Shanghai Cuisine​",
    step4_q_opt9: "Great World, Cantonese Cuisine​",
    step4_q_opt10: "Great World, Steamboat",
    step4_q_opt11: "ION Orchard, Steamboat",
    step4_q_opt12: "111 Somerset, Steamboat",
    step4_q_opt13: "Paragon, Yi Dian Xin",
    step4_q_opt14: "Parkway Parade, Yi Dian Xin",
    step4_q_opt15: "Raffles City, Yi Dian Xin",
    step4_q_opt16: "口コミ",
    step4_q_opt17: "ソーシャルメディア",
    step4_q_opt18: "その他",
    step4_q_opt19: "Jewel Changi Airport, Super Peking Duck",
    step4_q_opt20: "Jewel Changi Airport, Yi Dian Xin",
    step4_q_opt21: "ION Orchard, Huaiyang Cuisine",
    promo_code: "プロモーションコード",
    promo_code_input_msg: "有効なプロモーションコードを入力してください（お持ちの場合）",
    promo_code_err_msg: "有効なプロモーションコードを入力してください。",
    promo_code_re_msg: "プロモーションコードは有効です！",
    total: "合計:",
    refresh: "再読み込み",
    captcha: "キャプチャ",
    captcha_errMsg: "Captchaが不正です",
    cancel: "キャンセル",
    next: "次へ",
    back: "戻る",
    submitForm: "進む",
    overtime: "ご登録セッションが20分以内に完了しなかったため、有効期限が切れてしまいました。ページは自動的に再読み込みされます。継続するには、ご登録プロセスを再開始してください。",
    time_remaining: "残り時間",
    time_note: "リマインダー: 登録完了まで20分かかります。\nお支払いが完了するまで、ブラウザを更新したり閉じたりしないでください。"
  },
  aboutUs: {
    aboutUs: "当グループについて",
    txt1: "インペリアル・トレジャー・レストラン・グループ",
    txt2: "2004年に第一号店を開店して以来、インペリアル・トレジャーは本格的な中華料理の絶妙な品揃えと卓越したサービスにこだわり続け、今や高級中華料理の代名詞となっています。",
    txt3: "シンガポールに拠点を置く当グループは、シンガポール以外にも、上海、広州、香港、仁川、日本、ロンドン、パリに20店舗以上のレストランを運営しています。",
    txt4: "多様なポートフォリオを持つインペリアル・トレジャーは、広東料理、上海料理、潮州料理、淮揚料理、グリル、スチームボート、点心など、さまざまな中華料理の伝統を網羅し、料理提供の幅を拡大し続けています。",
    txt5: "当グループは、ミシュランガイド、アジアのベストレストラン50、美団点評の黒真珠レストランガイドなどから絶賛を受けた他、庄布忠の選ぶ世界のトップ中華レストランにも選ばれるなど、50以上の権威ある賞を受賞し、高級中華料理の分野でリーダーとしての地位を確立しています。",
  },
  faqs: {
    faqs: "よくあるご質問",
    general: "概要",
    general_1: "インペリアル・トレジャー・クラブとは？",
    general_1_1: "インペリアル・トレジャー・クラブは、プログラムに参加している国内外のインペリアル・トレジャー各店で会員の方がお食事をするたびに、会員限定の特典や報酬をお楽しみいただけるのロイヤリティプログラムです。",
    general_2: "インペリアル・トレジャー・クラブの会員になる方法は？",
    general_2_1: "<link>members.imperialtreasure.co.jp<link>でのオンライン登録が可能です。",
    general_3: "日本でプログラムに参加しているレストランはどこですか？",
    general_3_txt: "プログラム参加の国内レストラン：",
    general_3_1_txt: "御宝軒 インペリアル・トレジャー",
    general_3_1_1_txt: "〒104-0061 東京都中央区銀座３丁目５−４ GARENビル12階 | 電話：03-6228-6848",

    general_3_1: "Imperial Treasure Bar + Grill",
    general_3_1_1: "Great World, #02-111 | Tel: (+65) 6733 2292",
    general_3_2: "Imperial Treasure Fine Chinese Cuisine",
    general_3_2_1: "Marina Bay Sands, Level 2 Dining, #02-04 | Tel: (+65) 6688 7788",
    general_3_3: "Imperial Treasure Super Peking Duck ",
    general_3_3_1: "Paragon, #05-42 | Tel: (+65) 6732 7838",
    general_3_3_2: "Asia Square Tower 1, #02-08 | Tel: (+65) 6636 1868",
    general_3_3_3: "Jewel Changi Airport, #01-219 | Tel: (+65) 6908 6689",
    general_3_4: "Imperial Treasure Fine Teochew Cuisine",
    general_3_4_1: "ION Orchard, #03-05 | Tel: (+65) 6736 2118",
    general_3_4_2: "Marina Bay Sands, Bay Level, #01-26 | Tel: (+65) 6688 7333",
    general_3_5: "Imperial Treasure Fine Shanghai Cuisine",
    general_3_5_1: "Takashimaya S.C, #04-22 | Tel: (+65) 6836 6909",
    general_3_6: "Imperial Treasure Cantonese Cuisine ",
    general_3_6_1: "Great World, #02-111 | Tel: (+65) 6732 2232",
    general_3_7: "Imperial Treasure Steamboat Restaurant",
    general_3_7_1: "ION Orchard, #04-12A | Tel: (+65) 6636 9339",
    general_3_7_2: "Great World, #01-140 | Tel: (+65) 6235 6008",
    general_3_7_3: "111 Somerset, #02-14 | Tel: (+65) 6235 3882",
    general_3_8: "Treasures Yi Dian Xin",
    general_3_8_1: "Paragon, #B1-08 | Tel: (+65) 6262 3662",
    general_3_8_2: "Parkway Parade, #02-14 | Tel: (+65) 6247 9218",
    general_3_8_3: "Raffles City, #B3-17 | Tel: (+65) 6262 1662",
    general_3_8_4: "Jewel Changi Airport, #01-221 | Tel: (+65) 6908 3668",
    general_3_9: "(*Imperial Treasure reserves the right to make changes to the list of participating restaurants without prior notice.)",
    general_3_10: "Imperial Treasure Huaiyang Cuisine",
    general_3_10_1: "ION Orchard, #04-12A | Tel: (+65) 6636 9339",

    general_4: "海外でプログラムに参加しているレストランはどこですか？",
    general_4_1: "プログラム参加の海外レストラン：",
    general_4_1_1: "シンガポール | 上海 | 広州 | 香港 | 仁川 | ロンドン | パリ",
    general_4_1_1_sg: "シンガポール",
    general_4_1_1_sh: "上海",
    general_4_1_1_gz: "広州",
    general_4_1_1_hk: "香港",
    general_4_1_1_ic: "仁川",
    general_4_1_1_ld: "ロンドン",
    general_4_1_1_pr: "パリ",

    general_5: "会員の有効期間は？",
    general_5_1: "会員資格は、サ登録日から1年間有効です。例）2025年1月18日に登録した場合、会員資格は2026年1月17日に失効します。",

    general_6: "会員資格の有効期限はどこで確認できますか？",
    general_6_1: "会員資格の有効期限は、メンバーズポータルにログインして確認できます。",

    general_7: "インペリアル・トレジャー・クラブの会員に申し込める最低年齢は何歳ですか？",
    general_7_1: "インペリアル・トレジャー・クラブの会員に申し込めるのは、18歳以上の方のみです。",

    general_8: "なぜインペリアル・トレジャー・クラブに個人情報の詳細を登録しなければならないのですか？",
    general_8_1: "<link>members.imperialtreasure.com.jp<link>に個人情報を登録して、アカウントを有効化してください。さらに、メンバーを対象とした今後のプロモーション・報酬・イベントへの招待などに関する最新情報も受け取ることができます！",

    general_9: "個人情報はどこで更新できますか？",
    general_9_1: "個人情報を更新または閲覧するには、<link>members.imperialtreasure.co.jp<link>のメンバーズポータルからアカウントにログインし、「プロフィール」をクリックしてください。生年月日を更新するためのサポートについては、<link>jp.club@imperialtreasure.com<link>までご連絡ください。",

    general_10: "i-ドル、電子バウチャー、その他のリワードを確認するにはどうすればよいですか？",
    general_10_1: "会員特典とリワード残高を確認するには、<link>members.imperialtreasure.co.jp<link>にログインしてください。",

    general_11: "パスワードを忘れた場合は？",
    general_11_1: "パスワードをリセットするには、<link>members.imperialtreasure.co.jp<link>のメンバーズポータルにアクセスし、「パスワードを忘れた」をクリックしてください。画面の指示に従ってパスワードをリセットしてください。",

    general_12: "会員アカウントに関して質問がある場合は？",
    general_12_1: "会員アカウントに関する質問がある場合は、<link>jp.club@imperialtreasure.com<link>までお問い合わせください。",


    general_13: "インペリアル・トレジャー・クラブの会員資格は譲渡可能ですか？",
    general_13_1: "いいえ。会員資格は譲渡できません。",

    general_14: "会員資格を終了するには？",
    general_14_1: "会員の方は、<link>jp.club@imperialtreasure.com<link> に書面で通知することにより、有効期限前にいつでも会員資格が終了できます。会員資格終了時に未使用である電子バウチャーの返金や早期発行は行われない事をご了承ください。また、会員資格の更新がない場合、未更新の会員資格は自動的に失効し、その時点で残っているi-ドルおよび/または未使用の電子バウチャーは全て没収されたものと見なされます。",

    tier: "会員タイプ",
    tier_1: "会員階層とは何ですか？",
    tier_1_1: "会員階層には、シルバー、ゴールド、ダイヤモンドの3つがあります。",
    tier_2: "シルバー / ゴールド / ダイヤモンド会員になる方法は？",
    tier_2_1: "シルバー会員の会員資格は招待制であり、招待を受けた時点で、オンラインでのサインアップが可能です。",
    tier_2_2: "ゴールド/ダイヤモンド会員になるためには、既存会員の方が会員年度内に合計130万円 / 330万円以上のお支払い額*に達する必要があります。",
    tier_2_3: "*ここでの「お支払い額」は、サービス料、消費税、割引、電子バウチャーの使用、インペリアル・トレジャー・ギフト券の購入を除いて計算されたものを意味します。 ",
    tier_2_4: "",
    tier_3: "会員タイプを維持する方法は？",
    tier_3_1: "ゴールド/ダイヤモンド会員を維持するには、会員年度内に合計130万円 / 330万円のお支払額*を達成し、会員タイプを更新するだけです。",
    tier_3_2: "*ここでの「お支払い額」は、サービス料、消費税、割引、電子バウチャーの使用、インペリアル・トレジャー・ギフト券の購入を除いて計算されたものを意味します。 ",
    tier_3_3: "",
    tier_3_4: "",

    membership: "会員特典およびリワード",

    membership_2: "会員特典の内容は？",
    membership_2_1_1: "無料特典",
    membership_2_1_2: "シルバー",
    membership_2_1_3: "ゴールド",
    membership_2_1_4: "ダイヤモンド",

    membership_2_2_1: "1 X 北京ダック",
    membership_2_2_2: "-",
    membership_2_2_3: "はい",
    membership_2_2_4: "-",

    membership_2_3_1: "ワイン１本",
    membership_2_3_2: "-",
    membership_2_3_3: "はい",
    membership_2_3_4: "-",

    membership_2_5_1: "シャンペン１本",
    membership_2_5_2: "-",
    membership_2_5_3: "-",
    membership_2_5_4: "はい",
    membership_2_6_1: "1 X 5万円分のボーナス電子バウチャー",
    membership_2_6_2: "-",
    membership_2_6_3: "-",
    membership_2_6_4: "はい",

    membership_3: "特典の有効期限はどうやって分かりますか？",
    membership_3_1: '特典の有効期限を確認するには、<link>members.imperialtreasure.co.jp<link> でメンバーズポータルにログインし、「バウチャー」セクションに反映されている詳細を表示してください。',

    membership_6: "インペリアル・トレジャー・クラブの会員である事を提示する方法は？",
    membership_6_1: "サービススタッフに携帯電話番号をご提示いただくだけで、会員である事が確認できます。",
    membership_7: "無料特典を受け取るには？",
    membership_7_1: "お料理/ワインのお引き換えには、1日前のご注文を要します。引き換えはインペリアル・トレジャーで可能です。会員特典の引き換えは、会員の方がご自身で行う必要があります（身分証明書の提示が必要です）。",
    membership_8: "インペリアル・トレジャー・クラブの会員ですが、法人顧客としての法人割引も享受できますか？",
    membership_8_1: "いいえ、法人割引とインペリアル・トレジャー・クラブ会員との併用はできません。法人顧客の方は、各領収書において法人割引またはインペリアル・トレジャー・クラブの会員資格のいずれか１つの選択となりますす。",
    membership_9: "他国のインペリアル・トレジャー・レストランで、インペリアル・トレジャー・クラブの会員特典を利用する事はできますか？",
    membership_9_1: "i-ドルは、国内外のすべてのインペリアル・トレジャー・レストランで獲得できます。i-ドルの変換は、お客様が登録された国およびインペリアル・トレジャーが選定した為替レートに基づいて行われます。電子バウチャーのご利用は、アカウントが登録されている国でのみ行えます。",
    membership_10: "インペリアル・トレジャー・クラブの会員資格は譲渡可能ですか？",
    membership_10_1: "いいえ。会員資格は譲渡できません。",

    point: "ポイントの獲得と引き換え",
    point1: "",

    point_2: "どうやってi-ドルを獲得しますか？",
    point_2_1: "国内外を問わず、1,000円*ご利用毎にi$１獲得 (*販促商品、サービス料、消費税、割引、電子バウチャーのご利用、祝祭アイテムを除く)。",
    point_2_1_1: "お食事の場には、会員の方ご自身がいらっしゃる必要があります（身分証明書の提示が必要です）。前回または遡及的なお食事の領収書に対するi-ドルの加算要求は受け付けられません。お支払い明細、電子バウチャー、獲得されたi-ドルがシステムに反映されるまでに、１営業日を要することがあります。複数の会員アカウントを統合したり、i-ドル獲得のために請求書を分割することは、厳格に禁止されています。会員資格の失効に伴い、蓄積されたi-ドル残額も失効します。会員資格が失効した後も、i-ドル残高には３ヶ月の猶予期間が与えられます。その期間内に5,000円分の電子バウチャーと引き換えてください。引き換えないまま期間が終了すると、i-ドル残高は没収されることになります。",

    point_3: "i-ドルの利用方法は？",
    point_3_1: "会員の方は50i-ドル獲得ごとに、会員年度内のみ使用可能な5,000円分の電子バウチャーを自動的に受け取ります。5,000円分の電子バウチャーは、プログラムに参加している国内のレストランでお食事をした際に、お支払いの一部としてご使用いただけます。会員特典をご利用される場合は、会員の方ご自身ががお食事時にいらっしゃる必要があります（身分証明書の提示が必要です）。会員の方は、特典が利用済みである事を証明するために、受領書に署名する必要があります。会員特典の利用のために、複数の会員アカウントを統合したり、請求書を分割することはできません。",
    point_3_1_1: "(*システムは毎日定められた時間にi-ドルを自動的に変換します)",

    point_4: "E-ストアでのオンライン購入で、i-ドルを獲得したり、会員特典を利用したりできますか？",
    point_4_1: "いいえ。i-ドルの獲得および/または会員特典の利用は、特に別途指定がない限り、参加しているレストランでのお支払いに限られます。",

    point_5: "i-ドルに有効期限はありますか？",
    point_5_1: "はい。i-ドルは会員年度内にのみ有効で、会員資格の失効と共に無効となります。会員資格が失効した後も、i-ドル残高には３ヶ月の猶予期間が与えられます。その期間内に5,000円分の電子バウチャーと引き換えてください。引き換えないまま期間が終了すると、i-ドル残高は没収されることになります。",

    point_6: "支払いを行うとi-ドルは直ぐに反映されますか？",
    point_6_1: "はい。システムは通常、即座にi-ドルの獲得を反映しますが、予期しない状況下でのネットワークの遅延によってズレが生じる場合がある事をご了承ください。",

    point_7: "複数の会員アカウントを使用してi-ドルを獲得し、会員特典を利用することはできますか？",
    point_7_1: "いいえ。i-ドルの獲得や会員特典の利用のために、複数の会員アカウントを統合することはできません。",

    point_8: "請求書を分割してi-ドルを獲得したり、会員特典を利用したりできますか？",
    point_8_1: "いいえ。請求書を分割してi-ドルを獲得したり、会員特典を利用したりすることはできません。",

    point_9: "私が不在の場合、家族や友人がi-ドルを獲得したり、会員特典を利用したりできますか？",
    point_9_1: "いいえ。会員特典の利用は、会員の方ご本人が行う必要があります。",

    point_10: "第三者プラットフォームを通じて行われたオンライン注文で、i-ドルを獲得したり、会員特典を利用したりすることはできますか？",
    point_10_1: "いいえ。第三者プラットフォームを通じて行われたオンライン注文は、i-ドルの獲得や会員特典の利用の対象になりません。",

    renewal: "Renewal",
    renewal_1: "How do I renew my membership?",
    renewal_1_1: "Renewal of membership can be done via the members' portal at members.imperialtreasure.com. Alternatively, you can renew your membership at any participating restaurants.",

    renewal_2: "How much is the renewal fee?",
    renewal_2_1: "You can renew your membership for S$38 nett.",

    renewal_3: "How do I renew my Gold/Diamond membership?",
    renewal_3_1: "Accumulate a total spend of at least S$10,888* and above (Gold) or S$28,888* and above (Diamond) within the current membership year to qualify for an automatic renewal upon the expiry of the current membership cycle. *Qualifying spend is calculated before service charge & prevailing government taxes.",

    renewal_4: "What will I get when I renew my Imperial Treasure Club membership?",
    renewal_4_1: "1 x S$50 Renewal e-voucher (valid for 3 months from date of issue), 1 x S$100 Birthday e-voucher (valid only during birthday month with a minimum spend of S$280 (before service charge & prevailing government taxes) in a single receipt) and 3 x S$30 Steamboat Soup Base e-vouchers (valid for 12 months, redeemable only for dine-in at any Imperial Treasure Steamboat Restaurant) will be credited to your account in the new membership cycle.",

    renewal_5: "Can I renew my Imperial Treasure Club membership before the expiry date?",
    renewal_5_1: "Yes. You may renew your membership via the members' portal at members.imperialtreasure.com within 1 month of expiry and the new membership cycle will commence from the original expiry date.",
  },
  tnc: {
    title: "Terms And Privacy",
    membership: "会員規約とプライバシー",
    membership_1_1: "1.1 Introduction",
    membership_1_1_1: 'Imperial Treasure Restaurant Group Pte Ltd (“Imperial Treasure”) would like to offer our privileged customers news and information regarding our products and services, including promotions, special offers and discounts. We are offering you the opportunity to become a member of the Imperial Treasure Club (a "Member") to enjoy special privileges that Imperial Treasure may offer from time to time.',
    membership_1_2: "1.2 Collection and use of personal data",
    membership_1_2_1: "If you become a Member, you will need to provide Imperial Treasure with certain personal information (including your name and contact details such as email address and phone number). You will need to provide us with your mobile number for us to identify you. Your mobile number will be your username or unique identifier as a Member. Any personal data held by us about you will be held in accordance with our Privacy Notice.",
    membership_1_3: "1.3 Membership Tiers",
    membership_1_3_1: "1.3.1 Membership registration, i-dollars, and e-vouchers",
    membership_1_3_1_1: "Where you sign-up to become a Member, you will be required to provide your mobile number, among other information we may require from you, in order to sign up for the membership. This may be required online or by our restaurant staff depending on the circumstances.",
    membership_1_3_1_2: "Membership is strictly non-transferable and shall only be enjoyed by the Member in person.",
    membership_1_3_1_3: "As a Member, you earn one (01) i-dollar at the rate specified on the membership programme website [https://members.imperialtreasure.co.jp] for the country in which you signed up, when you spend at any participating Imperial Treasure restaurants (excluding service charge, GST/VAT, e-vouchers used, and the purchase and use of Imperial Treasure gift vouchers). Please refer to the Member’s Portal for a list of participating Imperial Treasure restaurants. Member must be physically present at the point of dining and provide the registered mobile number to the service staff in order to earn i-dollars. Earning of i-dollars must be made at the point of transaction. Requests on i-dollar accumulation for previous or backdated receipts will not be entertained. The system may require up to one (01) working day to reflect the transactions, e-vouchers and i-dollar earned. I-dollars accrued shall expire upon expiry of the membership. Any i-dollar accrued is however granted a three (03) months grace period and must be converted to e-vouchers within this grace period, failing which such i-dollar shall be deemed forfeited. Transactions made via third party vendors are not eligible for earning of i-dollars.",
    membership_1_3_1_4: "Earned i-dollars are converted in the Member Portal into Imperial Treasure e-vouchers of a specified value (“e-vouchers”) at the rate specified on the membership programme website [https://members.imperialtreasure.com/] for the country in which you signed up. Each e-voucher is valid for twelve (12) months from date of issue and valid for use within the membership period only. The e-voucher can be used to offset the bill when dining at any participating Imperial Treasure restaurants, subject to Imperial Treasure’s sole discretion and any other terms and conditions stated at [https://members.imperialtreasure.co.jp]. Neither i-dollars nor e-vouchers have any cash value and cannot be converted or redeemed for cash.",
    membership_1_3_2: "1.3.2 Membership Tiers",
    membership_1_3_2_1: "Unless otherwise determined by Imperial Treasure in its sole discretion, Silver Tier status is conferred on Members when they first join the membership programme and is valid for the period specified on the membership programme website [https://members.imperialtreasure.co.jp] for the country in which you signed up. At the end of this period, if the Member has not been upgraded to the Gold Tier or Diamond Tier, the Member may be required to pay such renewal fee as may be prescribed by Imperial Treasure in its sole discretion on the membership website [https://members.imperialtreasure.co.jp] for the country in which you signed up. ",
    membership_1_3_2_2: "Gold Tier status is conferred on Members who spend at least the amount set out for Gold Tier on the membership programme website [https://members.imperialtreasure.com/] for the country in which you signed up, at participating Imperial Treasure restaurants within twelve (12) months. Gold Tier status is valid for twelve (12) months from the date the Member qualifies; after that, annual requalification is required. Upon expiration of your membership tenure as a Gold Tier member, and if you have not met the minimum spend requirement to be retained in the tier, you shall be downgraded to Silver Tier status.",
    membership_1_3_2_3: "Diamond Tier status is conferred on Members who spend at least the amount set out for Diamond Tier on the membership programme website [https://members.imperialtreasure.co.jp] for the country in which you signed up, at participating Imperial Treasure restaurants within twelve (12) months. Diamond Tier status is valid for twelve (12) months from the date the Member qualifies; after that, annual requalification is required. Upon expiration of your membership tenure as a Diamond Tier member, and if you have not met the minimum spend requirement to be retained in the tier, you shall be downgraded to Gold Tier or Silver Tier status accordingly.",
    membership_1_3_2_4: "Imperial Treasure may, in its sole discretion, alter, limit, or modify the Silver Tier, Gold Tier and/or Diamond Tier programme rules, regulations, benefits, eligibility for membership, or any other feature of the Silver Tier, Gold Tier and/or Diamond Tier programme and/or may terminate the Silver Tier, Gold Tier and/or Diamond Tier programme at any time in its sole discretion, by giving reasonable notice on the membership programme website and/or by email. Please check the membership programme website regularly for updates. ",
    membership_1_3_3: "1.3.3 Membership Tier Rewards",
    membership_1_3_3_1: "Each membership tier also entitles Members to certain rewards and privileges, which may include other e-vouchers, free gifts and/or other dining benefits (“Rewards”). The current tier privileges are as set out in the membership programme website [https://members.imperialtreasure.co.jp]. The validity and terms and conditions of such Rewards are as set out in [https://members.imperialtreasure.com/], which may be amended by Imperial Treasure at any time in its sole discretion, by giving reasonable notice on the membership programme website and/or by email. Rewards are always subject to availability. Imperial Treasure reserves the right to replace a Reward with another Reward of equivalent or similar value. Rewards do not have any cash value and cannot be converted or redeemed for cash.",
    membership_1_3_4: "1.3.4 Redemption of Rewards and e-vouchers",
    membership_1_3_4_1: "Member must be physically present (proof of identification required) at the point of dining to redeem any membership privileges. Member is required to sign off on the receipt to acknowledge the redemption(s) made. Redemption of Rewards are subject to prevailing local law requirements.",
    membership_1_3_4_2: "Combining multiple membership accounts, combining bills or splitting the bills to earn i-dollars and/or redeem Rewards and membership privileges is strictly not allowed. Membership must be active at the point of redemption.",
    membership_1_4: "1.4 Amending personal data and terminating membership",
    membership_1_4_1: `You may amend your personal data or marketing preferences at any time via https://members.imperialtreasure.co.jp  (the "Member's Portal"). You will need to inform us in writing at jp.club@imperialtreasure.com should you choose to terminate your membership. Please allow a few working days for changes to take effect. Kindly be advised that there will be no refunds made and/or early issuance of any unused e-vouchers at the point of termination. Alternatively, your membership will automatically expire upon non-renewal of membership, and all balance i-dollars and/or unused e-vouchers will be deemed forfeited`,
    membership_1_5: "1.5 Termination and cancellation",
    membership_1_5_1: "We reserve the right to terminate the Member's membership if the membership account is found to be shared with another non-Member.",
    membership_1_5_2: "We reserve the right to terminate your membership, in our absolute discretion, should you abuse any of the conditions and privileges bestowed on you as a Member.",
    membership_2: "2. Law and forum",
    membership_2_1: `These Membership Terms, including all policies and additional terms referenced herein (this "Membership Agreement"), are governed by, and construed in accordance with the laws of Singapore. Any dispute or claim arising out of or in connection with this Membership Agreement (including non-contractual disputes or claims) shall be subject to the non-exclusive jurisdiction of Singapore courts.`,
    membership_2_2: "If you are a consumer, you will benefit from any mandatory provisions of the laws of the country in which you are habitually resident. Nothing in this Membership Agreement affects your rights as a consumer to rely on such mandatory provisions of local law.",
    membership_3: "3. Consent",
    membership_3_1: "I would like to join the Imperial Treasure Membership Club and I consent to the collection, holding, use and disclosure of my personal data in accordance with your Privacy Notice. If I provide Imperial Treasure with any personal data relating to a third party, by submitting such information, I represent and warrant that I have obtained the consent of the third party for Imperial Treasure to collect, use and disclose their personal data in accordance with this Privacy Notice.",
    privacy: "Privacy Notice",
    privacy_1: "1. INTRODUCTION",
    privacy_1_1: 'Imperial Treasure Restaurant Group Pte Ltd, Imperial Treasure Cantonese Cuisine Pte Ltd, Imperial Treasure Noodle House Pte Ltd, Imperial Treasure Fine Dining Restaurant Pte Ltd, Multirich F&B Management Pte Ltd, Imperial Treasure Windows of Hong Kong Pte Ltd and Imperial Treasure Steamboat Pte Ltd (collectively referred as "Imperial Treasure", "us", "we") is committed to protecting the privacy of visitors to this website and our mobile application (the "Website"). This Privacy Notice sets out how Imperial Treasure collects, uses or discloses personal data that you have provided to us through the Website. By visiting the Website, you are accepting and consenting to the collection, use and disclosure of personal data described in this Privacy Notice. If you do not agree with this Privacy Notice, please do not use the Website. This Privacy Notice does not apply to other websites to which we link ("Third Party Website" or "Third Party Websites"). ',
    privacy_1_2: "This Privacy Notice also describes your data protection rights, including a right to object to some of the processing which Imperial Treasure carries out. More information about your rights, and how to exercise them, is set out in the following section: “8. What rights do I have”.",
    privacy_1_3: 'Maintaining the privacy of our customers’ information is important to us. We do not disclose rent or sell our customers’ personal data to third parties (except as described in "5. Disclosures of personal data to third parties").',
    privacy_1_4: "Imperial Treasure Restaurant Group Pte Ltd (https://www.imperialtreasure.com/contact) is responsible for sharing personal data among Imperial Treasure in accordance with this Privacy Notice.",
    privacy_2: "2. COLLECTION AND USE OF PERSONAL DATA",
    privacy_2_1: "We collect the following personal data when you register as a user of the Website and make purchases through the Website:",
    privacy_2_1_1: "email address",
    privacy_2_1_2: "your name, address and phone number (including delivery addresses if different);",
    privacy_2_1_3: "billing address, including your name, address and phone number; and",
    privacy_2_1_4: "any other personal data provided to us when you submit any comment, question or feedback to us, request services from us, or disclose your personal data to us in any way.",
    privacy_2_2: "We may collect, use and disclose your personal data for the following purposes:",
    privacy_2_2_1: "To fulfil a contract, or take steps linked to a contract: this is relevant where you make a purchase from us. This includes to:",
    privacy_2_2_1_1: "fulfil your order and deliver it to you;",
    privacy_2_2_1_2: "facilitate and track your purchases from us (including in our restaurants or via our websites); and",
    privacy_2_2_1_3: "provide you with service support.",
    privacy_2_2_2: "As required by Imperial Treasure to conduct our business and pursue our legitimate interest, in particular:",
    privacy_2_2_2_1: "to facilitate your registration as a user of the Website;",
    privacy_2_2_2_2: "to use information you provide to provide products and services you have requested;",
    privacy_2_2_2_3: "(if you use a card payment for any purchase on the Website) we use third parties to check the validity of the sort code, account number and card number you submit in order to prevent fraud; and;",
    privacy_2_2_2_4: "to respond to comments, queries and feedback.",
    privacy_2_2_3: "Where you give us consent:",
    privacy_2_2_3_1: "we provide you with marketing and promotional material and other information about our products (including promotions and special offers), as well as other products and services provided by our affiliates and partners; and",
    privacy_2_2_3_2: "on other occasions where we ask you for consent, we will use the personal data for the purposes which we explain at that time.",
    privacy_2_2_4: "For purposes which are required by law: to comply with legal and regulatory obligations, carry out internal audits or investigations, prevent fraud or other unlawful activities, or ensure the safety and security of you and us.",
    privacy_2_2_5: "For purposes that are reasonably necessary or ancillary to the abovementioned purposes.",
    privacy_2_2_6: "For any other purposes which we may have notified you prior to, or at the time of, obtaining your consent.",
    privacy_2_3: "The provision of your name, family name, contact number, gender, date of birth, country code and email address are mandatory so that we can contact you and fulfil any of your order(s): if any required data is not provided, then we will not be able to fulfil your order(s). All other provision of your information is optional.",
    privacy_2_4: "Additionally, through the Website, we may gather certain aggregated and anonymous information about the use of the Website, such as how frequently certain areas of the Website are visited, including through the use of cookies, web beacons, Google Analytics and other technologies.",
    privacy_2_5: "We may use cookies, web beacons, Google Analytics and other technologies for the following purposes:",
    privacy_2_5_1: "to identify the causes of problems arising at web servers and to resolve these problems;",
    privacy_2_5_2: "to improve the contents of the Website;",
    privacy_2_5_3: "to customize the content of the Website and our emails to suit your individual interests or purposes and selectively display best-matched pages to you, including tracking your past purchases in order to provide you with new services or special promotions;",
    privacy_2_5_4: "to utilize your browsing history on the Website for demographic research; and",
    privacy_2_5_5: "to obtain statistic data of web visitors and aggregated website visitation statistics which are anonymous in nature.",
    privacy_2_6: "You may reject our use of cookies by configuring your browser to disable the use of cookies. However, you may no longer be able to receive services or personalized features of the Website which rely on the use of cookies.",
    privacy_2_7: "For information about the data gathered by Google in connection with Google Analytics, please see the relevant policy provided by Google at ([GA4] Data collection - Analytics Help",
    privacy_3: "3. SENDING OF EMAILS TO MEMBERS",
    privacy_3_1: "Genuine emails from Imperial Treasure always will come from an address ending @imperialtreasure.com. Do not open any attachments or click any links from suspicious emails. If you wish to report a suspicious email claiming to be from Imperial Treasure that you believe is a forgery, you may email to jp.marketing@imperialtreasure.com",
    privacy_4: "4. WITHDRAWING CONSENT OR OTHERWISE OBJECTING TO DIRECT MARKETING",
    privacy_4_1: "Wherever we rely on your consent, you will always be able to withdraw that consent, although we may have other legal grounds for processing your personal data for other purposes, such as those set out above. You have an absolute right to opt-out of direct marketing, or profiling we carry out for direct marketing, at any time. You can do this by following the instructions in the communication where it is an electronic message, or by contacting us using the details set out below.",
    privacy_4_2: 'Where you have provided us with your consent, Imperial Treasure, our affiliates, related entities, and third parties acting on our behalf ("Business Partners"), may collect, use and disclose your personal data, which you have provided at the Member\'s Portal, for providing marketing material that you have agreed to receive, in accordance with the Personal Data Protection Act 2012 and our Privacy Notice. Please note that marketing material may be sent directly by our Business Partners, and we may disclose your personal data to them for that purpose.',
    privacy_5: "5. DISCLOSURES OF PERSONAL DATA TO THIRD PARTIES",
    privacy_5_1: "In order to provide services to you and for the purposes listed at “2 Collection and Use of Personal Data” above, we may disclose and/or transfer your personal data out of Singapore, as described in this Privacy Notice:",
    privacy_5_1_1: "We may share your personal data with our affiliated companies for the purposes of fulfilling a contract with you, providing customer services and membership services, and facilitating your registration as a user of the Website:",
    privacy_5_1_2: "We may permit certain trusted third parties to access your personal data in connection with their performance of services to maintain and operate the Website and certain features on the Website. For example, we may use third parties to host the Website; operate various features available on the Website; send emails; analyze data; provide search results and links and assist in fulfilling your orders and may share personal data or other information with our parent, subsidiaries, divisions, and affiliates.",
    privacy_5_1_3: "We may employ a third-party service to collect the above-mentioned information, including personal data, and use their tracking services on our behalf. However, this information is strictly confidential and will not be shared with others.",
    privacy_5_1_4: "We may disclose personal data as an asset in connection with a proposed or actual merger or sale (including any disclosures made as part of an insolvency or bankruptcy proceeding) involving all or part of our business or as part of a corporate reorganization, stock sale or other change in control.",
    privacy_5_1_5: "We reserve the right to disclose information, including personal data, in order to comply with a subpoena, court order, administrative or governmental order, or any other requirement of law, or when we, in our sole discretion, believe it is necessary in order to protect our rights or the rights of others, to prevent harm to persons or property, to fight fraud and credit risk reduction. We may also disclose or transfer personal data as otherwise permitted or required by law; and",
    privacy_5_1_6: "We may disclose aggregated and anonymized data to third parties.",
    privacy_5_2: "Your personal data may be transferred out of Singapore from time to time. Such transfers will be carried out in accordance with the Singapore Personal Data Protection Act 2012.",
    privacy_6: "6. HOW WE PROTECT YOUR INFORMATION",
    privacy_6_1: "We are committed to protecting the information we receive from you. We adopt reasonable physical, technical and administrative practices to help protect the confidentiality, security and integrity of data, including personal data, stored on our system. We believe the measures we have implemented reduce the likelihood of security problems to a level appropriate to the type of data involved. Although we take reasonable steps to protect the information we receive from you, no computer system is completely secure, and we cannot be held liable for any loss you may suffer for unauthorized access or loss of any data provided to the Website, unless such loss is due to our willful misconduct or gross negligence.",
    privacy_7: "7. LINKS TO THIRD PARTY SITES",
    privacy_7_1: "The Website may contain links to third party websites and microsites, including third party payment gateways, whose privacy practices may differ from those of ours. If you submit personal data, including payment information, to any of those websites, that personal data is not subject to this Privacy Notice and will be subject to the third party's privacy practices instead.",
    privacy_7_2: "We therefore encourage you to review the privacy statement of any website you visit. By clicking on or activating such links and leaving the Website, we can no longer exercise control over any data or information which you give to any other entity after leaving the Website, and any access to such other websites is entirely at your own risk.",
    privacy_8: "8. WHAT RIGHTS DO I HAVE",
    privacy_8_1: "You have the right to ask us for a copy of your personal data; to access or correct; and to obtain the personal data you provide to us for a contract or with your consent in a structured, machine readable format, and to ask us to share (port) this data to another data controller.",
    privacy_8_2: "These rights may be limited, for example if fulfilling your request would reveal personal data about another person or where they would infringe the rights of a third party (including our rights). Relevant exemptions are included in the applicable laws and regulations. We will inform you of relevant exemptions we rely upon when responding to any request you make.",
    privacy_8_3: "To exercise any of these rights, or to obtain other information, such as a copy of a legitimate interests balancing test, you can get in touch with us – by contacting our Data.",
    privacy_8_4: 'Protection Officer (See "11. Contact us" below). To access and correct your personal data, you can do so by signing into your user account and updating your personal data. We will only disclose personal data in accordance with an access request to the individual who registered his/her personal data with the Website, and only after confirming that the person requesting access is indeed the registered party.',
    privacy_8_5: "You may also contact our Data Protection Officer to withdraw your consent to our use of your personal data.",
    privacy_8_6: "Please allow thirty (30) days for your request to be processed.",
    privacy_9: "9. RETENTION OF INFORMATION",
    privacy_9_1: "Where we process registration data, we do this for as long as you are an active user of the Website and for six (6) years after this.",
    privacy_9_2: "Where we process personal data for marketing purposes or with your consent, we will process such data until you ask us to stop and for a short period after this (to allow us to implement your requests). We also keep a record of the fact that you have asked us not to send you direct marketing or not to process your data so that we can respect your request in the future.",
    privacy_9_3: "Where we process personal data in connection with performing a contract, we keep such data for six (6) years from your last interaction with us",
    privacy_9_4: "If you withdraw your consent to our collection, use or disclosure of your personal data, we may not be able to provide you with services that require such personal data. Please also note that your personal data may still be retained on our database to the extent permitted by law.",
    privacy_10: "10. PRIVACY NOTICE CHANGES",
    privacy_10_1: "If we decide to change our Privacy Notice for the Website, we will post the revised Privacy Notice here and, if appropriate, notify you by email. Please check back frequently to see any updates or changes to our Privacy Notice.",
    privacy_11: "11. CONTACT US",
    privacy_11_1: "If you have any questions about this Privacy Notice, please contact our Data Protection Officer at DPO@imperialtreasure.com.",
  },
  outlets: {
    outlets: "プログラム参加レストラン",
    restaurant_name: "レストラン名",
    address: "所在地",
    contact: "お問い合わせ",
    email: "Eメールアドレス",
    outlets_1_1: "御宝軒 インペリアル・トレジャー",
    outlets_1_2: "〒104-0061 東京都中央区",
    outlets_1_3: "銀座3-5-4 GAREN 12階",
    outlets_1_4: "+81 3-62286848",
    outlets_1_5: "finechinese_ginza@imperialtreasure.com",
    outlets_2_1: "Imperial Treasure Super Peking Duck\nParagon",
    outlets_2_2: "Paragon, #05-42/45,",
    outlets_2_3: "290 Orchard Road, Singapore 238859",
    outlets_2_4: "(+65) 6732 7838",
    outlets_2_5: "paragon@imperialtreasure.com",
    outlets_3_1: "Imperial Treasure Super Peking Duck\nAsia Square",
    outlets_3_2: "Asia Square Tower 1, #02-08/10,",
    outlets_3_3: "8 Marina View, Singapore 018960",
    outlets_3_4: "(+65) 6636 1868",
    outlets_3_5: "asq@imperialtreasure.com",
    outlets_4_1: "Imperial Treasure Fine Teochew Cuisine\nION Orchard",
    outlets_4_2: "ION Orchard, #03-05,",
    outlets_4_3: "2 Orchard Turn, Singapore 238801",
    outlets_4_4: "(+65) 6736 2118",
    outlets_4_5: "fineteochew_ion@imperialtreasure.com",
    outlets_5_1: "Imperial Treasure Fine Teochew Cuisine\nMarina Bay Sands",
    outlets_5_2: "Marina Bay Sands, Bay Level, #01-26",
    outlets_5_3: "2 Bayfront Avenue, Singapore 018972",
    outlets_5_4: "(+65) 6688 7333",
    outlets_5_5: "fineteochew_mbs@imperialtreasure.com",
    outlets_6_1: "Imperial Treasure Fine Shanghai Cuisine\nTakashimaya S.C.",
    outlets_6_2: "Takashimaya S.C., #04-22,",
    outlets_6_3: "391 Orchard Road, Singapore 238872",
    outlets_6_4: "(+65) 6836 6909",
    outlets_6_5: "sh_nac4@imperialtreasure.com",
    outlets_7_1: "Imperial Treasure Cantonese Cuisine\nGreat World",
    outlets_7_2: "Great World, #02-111,",
    outlets_7_3: "1 Kim Seng Promenade, Singapore 237994",
    outlets_7_4: "(+65) 6732 2232",
    outlets_7_5: "cc_gwc@imperialtreasure.com",
    outlets_8_1: "Imperial Treasure Bar + Grill\nGreat World",
    outlets_8_2: "Temporarily Closed",
    outlets_8_3: "Great World, #02-111,",
    outlets_8_4: "1 Kim Seng Promenade, Singapore 237994",
    outlets_8_5: "(By Reservation only)",
    outlets_8_6: "(+65) 6733 2292",
    outlets_8_7: "bar_grill_gw@imperialtreasure.com",
    outlets_9_1: "Imperial Treasure Steamboat Restaurant\nION Orchard",
    outlets_9_2: "ION Orchard, #04-12A,",
    outlets_9_3: "2 Orchard Turn, Singapore 238801",
    outlets_9_4: "(+65) 6636 9339",
    outlets_9_5: "ion_steamboat@imperialtreasure.com",
    outlets_10_1: "Imperial Treasure Steamboat Restaurant\nGreat World",
    outlets_10_2: "Great World, #01-140,",
    outlets_10_3: "1 Kim Seng Promenade, Singapore 237994",
    outlets_10_4: "(+65) 6235 6008",
    outlets_10_5: "steamboat_gwc@imperialtreasure.com",
    outlets_11_1: "Imperial Treasure Steamboat Restaurant\n111 Somerset",
    outlets_11_2: "111 Somerset, #02-14/19,",
    outlets_11_3: "111 Somerset Road, Singapore 238164",
    outlets_11_4: "(+65) 6235 3882",
    outlets_11_5: "steamboat_111@imperialtreasure.com",
    outlets_12_1: "Treasures Yi Dian Xin\nParagon",
    outlets_12_2: "Paragon, #B1-08,",
    outlets_12_3: "290 Orchard Road, Singapore 238859",
    outlets_12_4: "(+65) 6262 3662",
    outlets_12_5: "paragon_ydx@imperialtreasure.com",
    outlets_13_1: "Treasures Yi Dian Xin\nParkway Parade",
    outlets_13_2: "Parkway Parade, #02-14/17,",
    outlets_13_3: "80 Marine Parade Road, Singapore 449269",
    outlets_13_4: "(+65) 6247 9218",
    outlets_13_5: "parkway_ydx@imperialtreasure.com",
    outlets_14_1: "Treasures Yi Dian Xin\nRaffles City",
    outlets_14_2: "Raffles City, #B1-37,",
    outlets_14_3: "252 North Bridge Road, Singapore 179103",
    outlets_14_4: "(+65) 6262 1662",
    outlets_14_5: "rafflescity_ydx@imperialtreasure.com",
    outlets_15_1: "Imperial Treasure Super Peking Duck\nJewel Changi Airport",
    outlets_15_2: "Jewel Changi Airport, #01-219,",
    outlets_15_3: "78 Airport Boulevard, Singapore 819666",
    outlets_15_4: "(+65) 6908 6689",
    outlets_15_5: "spd_jewel@imperialtreasure.com",
    outlets_16_1: "Treasures Yi Dian Xin\nJewel Changi Airport",
    outlets_16_2: "Jewel Changi Airport, #01-221,",
    outlets_16_3: "78 Airport Boulevard, Singapore 819666",
    outlets_16_4: "(+65) 6908 3668",
    outlets_16_5: "jewel_ydx@imperialtreasure.com",
    outlets_17_1: "Imperial Treasure Huaiyang Cuisine\nION Orchard",
    outlets_17_2: "ION Orchard, #04-12A,",
    outlets_17_3: "2 Orchard Turn, Singapore 238801",
    outlets_17_4: "(+65) 6636 9339",
    outlets_17_5: "huaiyang_ion@imperialtreasure.com",
  },
  privilege: {
    title: "会員特典",
    privilege: "会員特典",
    privelege_txt: "国内外を問わず、プログラム参加のレストランで1,000円*ご利用毎に１i-ドル獲得できます",
    privelege_txt2: "50i-ドル貯めると、国内の参加レストランで使える5,000円分の電子バウチャーが受け取れます",
    silver: "シルバー",
    silver_signup: "招待限定",
    silver_1: "",
    silver_2: "",
    silver_3: "",
    silver_renewal: "",
    silver_4: "",
    silver_5: "",
    silver_6: "",
    gold: "ゴールド",
    gold_1: "入会/更新から一年位内に130万円*以上のお食事をされた場合、ゴールド会員にアップグレードされます。",
    gold_2: "無料特典:",
    gold_3: "1羽 北京ダック",
    gold_4: "ワイン１本",
    gold_5: "",
    gold_6: "",
    gold_7: "",
    diamond: "ダイヤモンド",
    diamond_1: "入会/更新から一年位内に330万円*以上のお食事をされた場合、ダイヤモンド会員にアップグレードされます。",
    diamond_2: "ゴールド*会員の各種特典に加え：",
    diamond_3: "1枚 5万円の電子お食事券",
    diamond_4: "シャンペン１本",
    diamond_5: "",
    remarks: "*販促商品、サービス料、消費税、割引、電子バウチャーのご利用、季節アイテムを除く \n^各会員様は、一会員サイクルにつき一セットのゴールド特典を受け取ることができます",
    sign_up_now: "今すぐ登録",
  },
  resetPassword: {
    title: "パスワードを忘れましたか？",
    reset_password: "パスワードをリセット",
    email: "*Eメールアドレスを入力してください",
    email_input: "Eメールアドレスを入力してください",
    email_errMsg: "有効なEメールアドレスを入力してください",
    mobile: "*携帯電話番号を入力してください",
    mobile_errMsg: "有効な携帯電話番号を入力してください",
    new_password: "*新しいパスワード",
    new_password_errMsg1: "パスワードを入力してください",
    new_password_errMsg2: "パスワードは、8文字以上の英数字からなり、少なくとも1つの大文字と1つの特殊文字（?!@$%&*）を含む必要があります。",
    confirm_password: "*新しいパスワードを確認する",
    confirm_password_errMsg: "パスワードを確認してください",
    reset_password2: "パスワードをリセット",
    has_been_reset: "パスワードがリセットされました！",
    login: "ログイン",
  },
  forgetPassword: {
    title: "パスワードを忘れました",
    reset_password: "パスワードをリセット",
    forgot_password: "パスワードを忘れましたか？",
    reset_pw_method: "パスワードリセット方法を選択してください",
    by_mobile: "携帯電話経由で",
    by_email: "Eメール経由で",
    email: "*Eメールアドレスを入力してください",
    email_input: "Eメールアドレスを入力してください",
    email_errMsg: "有効なEメールアドレスを入力してください",
    mobile: "*携帯電話番号を入力してください",
    mobile_errMsg: "有効な携帯電話番号を入力してください",
    reset_password2: "パスワードをリセット",
    reset_password_sent_email: "パスワードリセット用のリンクがEメールに送信されました。",
    reset_password_sent_mobile: "パスワードリセットリンクが携帯電話に送信されました",
    next: "次へ",
    back: "戻る",
  },
  updateEmail: {
    title: "Eメールを更新",
    member_profile: "メンバープロフィール",
    updateEmail: "Eメールを更新",
    new_email: "*新しいEメールアドレス",
    sent: "送信済み",
    send_token: "トークンを送信",
    email_errMsg1: "有効なEメールアドレスを入力してください",
    email_errMsg2: "Eメールアドレスはすでに登録されています",
    token: "*トークン",
    token_error: "トークンエラー",
    update: "更新",
    update_success: "無事に更新されました！",
    done: "完了",
    Msg1: "携帯電話とEメールの両方が既に登録されています",
    Msg2: "Eメールアドレスはすでに登録されています",
  },
  updateMobile: {
    title: "携帯電話を更新",
    member_profile: "メンバープロフィール",
    updateMobile: "携帯電話を更新",
    new_mobile: "*新しい携帯電話番号",
    sent: "送信済み",
    send_token: "トークンを送信",
    mobile_errMsg1: "有効な携帯電話番号を入力してください",
    mobile_errMsg2: "この携帯電話番号はすでに登録されています。",
    token: "*トークン",
    token_error: "トークンエラー",
    update: "更新",
    update_success: "無事に更新されました！",
    done: "完了",
    Msg1: "携帯電話とEメールの両方が既に登録されています",
    Msg2: "Eメールアドレスはすでに登録されています",
  },
  coupon: {
    title: "バウチャー",
    member_profile: "メンバープロフィール",
    coupon: "バウチャー",
    birthdayNote: "お客様の誕生日の電子バウチャーは、お誕生月にのみご利用可能です。",
    active: "アクティブ",
    redeemed: "引き換え済み",
    expired: "期限切れ",
    type_of_vouchers_opt1: "バウチャーの種類を選んでください",
    type_of_vouchers_opt2: "Type A",
    type_of_vouchers_opt3: "Type B",
    type_of_vouchers_opt4: "Type C",
    type_of_vouchers_opt5: "Type D",
    expiry_date: "有効期限:",
    redeemed_store: "ご利用先/引き換えアウトレット:",
    vaild_date: "有効期間満了日",
    description: "内容記述",
    vouchers_code: "バウチャーコード",
    done: "完了",
    no_coupon_msg: "ご利用できるバウチャーはありません",
    previous: "前へ",
    next: "次へ"
  },
  editProfile: {
    title: "プロフィールの編集",
    member_profile: "メンバープロフィール",
    editProfile: "プロフィールの編集",
    general: "概要",
    security: "セキュリティ  ",
    subscriptions: "購読",
    salutation: "*敬称",
    salutation_opt1: "敬称を選択してください",
    salutation_opt2: "Mr",
    salutation_opt3: "Mrs",
    salutation_opt4: "Mdm",
    salutation_opt5: "Miss",
    salutation_opt6: "Dr",
    salutation_errMsg: "敬称を選択してください",
    gender: "*性別",
    gender_opt1: "性別を選択してください",
    gender_opt2: "男性",
    gender_opt3: "女性",
    gender_errMsg: "性別を選択してください",
    first_name: "*名",
    first_name_errMsg: "名を記入してください",
    last_name: "*姓",
    last_name_errMsg: "姓を記入してください",
    birth: "*生年月日",
    mobile: "*携帯電話番号",
    mobile_change: "変更",
    email: "*Eメールアドレス",
    email_change: "変更",
    language: "*ご希望の言語",
    language_opt1: "ご希望の言語を選択してください",
    language_opt2: "English",
    language_opt3: "日本語",
    language_opt4: "中文",
    update: "更新 ",
    previous_password: "*前パスワード",
    previous_password_errMsg: "前パスワードが正しくありません",
    new_password: "*新しいパスワード",
    new_password_errMsg1: "パスワードを入力してください",
    new_password_errMsg2: "パスワードは、8文字以上の英数字からなり、少なくとも1つの大文字と1つの特殊文字（?!@$%&*）を含む必要があります。",
    confirm_password: "*パスワードを確認する",
    confirm_password_errMsg: "パスワードを確認してください",
    subscriptions_txt1: "下のボックスにチェックを入れる事で、私はインペリアル・トレジャー・グループPte Ltd（以降「ITRG」とする）に、私が提供した私の個人情報、またはインペリアル・トレジャー・クラブ会員の権利を私が利用する事に関わるデータ（以降「データ」とする）、あるいはその双方を、インペリアル・トレジャーがその関連会社あるいは第三者と共有する事を目的に、収集・使用・蓄積・開示のいずれかまたは全てを行うことを許可します。これにより私は、私の会員特権またはロイヤリティープログラムの特典を十分に楽し<link>会員規約とプライバシー<link>むことができ、そこにはインペリアル・トレジャーが持つシンガポール国外のサービス提供者との関係性により派生する特典も含まれるからです。",
    subscriptions_txt2: "インペリアル・トレジャーからマーケティング関連のメッセージを受信する事に同意します(オプション)。",
    by_email: "Eメール経由で",
    by_mobile: "携帯電話経由で",
    update_success: "無事に更新されました！",
    done: "完了",
    password_update_success: "パスワードが無事に更新されました！",
  },
  profile: {
    title: "会員",
    logout: "ログアウト",
    click_to_renew: "クリックして更新する​",
    activation_now: "今すぐ有効にする",
    menber_id: "会員ID:",
    member: "会員",
    active: "アクティブ",
    expired: "期限切れ",
    salutation: "敬称:",
    mobile: "携帯電話番号:",
    birth: "生年月日:",
    password: "パスワード:",
    ellipsis: "········",
    change: "変更",
    gender: "性別:",
    email: "Eメールアドレス:",
    cycle_start_date: "階層開始日:",
    first_joined_date: "参加初日:",
    optin_email: "オプトインメール:",
    optin_sms: "オプトインSMS:",
    cycle_expiry_date: "サイクル有効期限:",
    language_preference: "ご希望の言語:",
    spend: "お支払い済み円",
    expires_on: "  有効期限日",
    spend_required: "必要なネット支払い額",
    to_upgrade_to: "アップグレードする",
    diamond_membership: "ダイヤモンド會員",
    nett_spend_required: "維持に必要なネット支払い額",
    nett: "ネット",
    to_maintain_to: "維持する",
    silver_member: "シルバー",
    gold_member: " ゴールド",
    diamond_member: " ダイヤモンド",
    total_nett_spend: "ネット支払い合計額",
    current_membership: "現在の会員年度で*",
    i_dollar: "i-ドル",
    last_update: "  最終更新 : ",
    i_dollar_earned: "獲得済みi-ドル",
    i_dollar_converted: "変換済みi-ドル",
    i_dollar_balance: "i-ドル残額",
    i_dollar_automatically: "50 i-ドルは自動的に5,000円分の電子バウチャーに変換されます",
    total_earned_converted: "Total i$ Earned & Converted ",
    i_dollar_available: "i$ Available\n(not yet in e-vouchers)",
    i_dollar_automatically2: "We automatically convert i$50 to a ¥5,000 e-voucher.\nYour i$ remain secure, they’re moved into e-vouchers.",
    vouchers: "バウチャー",
    currently_active: "現在有効です",
    cash_vouchers: "現金バウチャー",
    food_vouchers: "お食事/プロモーションバウチャー",
    click_to_view: "クリックして表示",
    transaction: "お取引",
    this_month: "今月",
    last_3_months: "過去3ヶ月",
    last_12_months: "過去12ヶ月",
    transaction_details: "お取引の詳細",
    transaction_date: "お取引日",
    transaction_time: "お取引時刻",
    outlet: "アウトレット",
    receipt: "領収書番号",
    payment_method: "お支払い方法",
    receipt_details: "領収書の詳細",
    zero: ".0000",
    i_dollars_eared: "獲得済みi-ドル:",
    total: "合計 :",
    done: "完了",
    thankyou_msg: "当店でお食事いただき、誠にありがとうございました！",
    activate_membership: "会員資格を有効にする",
    activate_membership_1: "Activate your membership with just S$20 to enjoy the following privileges:",
    activate_membership_2: "Earn i$1 with every $10 spent. Accumulate i$50 to receive a $50 e-voucher",
    activate_membership_3: "1 x S$50 Renewal e-voucher (valid for 3 months)",
    activate_membership_4: "1 X S$100 Birthday e-voucher, minimum spend of S$280 applies, valid only during birthday month",
    activate_membership_5: "3 x S$30 Steamboat Soup Base e-vouchers (valid for 12 months)",
    activate_membership_7: "Be the first to receive latest updates and exclusive invitations to private events! ",
    renew_membership: "会員を更新する",
    renew_membership_1: "Renew your membership with just S$20 to enjoy the following privileges:",
    renew_membership_2: "Earn i$1 with every $10 spent. Accumulate i$50 to receive a $50 e-voucher",
    renew_membership_3: "1 x S$50 Renewal e-voucher (valid for 3 months)",
    renew_membership_4: "1 x S$100 Birthday e-voucher, minimum spend of S$280 applies, valid only during birthday month",
    renew_membership_5: "3 x S$30 Steamboat Soup Base e-vouchers (valid for 12 months)",
    renew_membership_6: "Be the first to receive latest updates and exclusive invitations to private events! ",
    confirm_to_renew: "確認して更新する",
    confirm_to_activate: "有効化を確認",
    change_password: "パスワードを変更する",
    previous_password: "*前パスワード",
    previous_password_errMsg: "前パスワードが正しくありません",
    new_password: "*新しいパスワード",
    new_password_errMsg1: "パスワードを入力して確認してください",
    new_password_errMsg2: "パスワードは、8文字以上の英数字からなり、少なくとも1つの大文字と1つの特殊文字（?!@$%&*）を含む必要があります。",
    confirm_password: "*パスワードを確認する",
    close: "Xで閉じる",
    member_activated: "会員資格が有効化されました",
    password_updated: "パスワードが更新されました",
    friend_referral: "Friend Referral",
    view_more: "VIEW MORE",
    add_friend: "ADD",
    silver_tier: "シルバー ",
    gold_tier: "ゴールド ",
    diamond_tier: "ダイヤモンド ",
    spend_date_format: "有効期限日",
  },
  friendReferral: {
    title: "Friend Referral",
    note1: "Refer a friend and you will get S$10 e-voucher for every successful referral.",
    note2: "For every successful referral, the referee will receive a Peking duck e-voucher to purchase our Signature Peking Duck at S$78 (U.P: S$178)",
    email: "Eメールアドレス",
    referee_email: "Referee's Email",
    emailAddress_errMsg: "有効なEメールアドレスを入力してください.",
    mobile: "携帯電話番号",
    referee_mobile: "Referee’s Mobile",
    mobile_errMsg: "有効な携帯電話番号を入力してください",
    mobile_errMsg2: "携帯電話番号は既に登録されています",
    name: "名",
    referee_name: "Referee's Name",
    name_errMsg: "Please enter referee's name.",
    referral_sucMsg: "You have successfully referred your friend!",
    referral_errMsg: "Referee is an existing registered Imperial Treasure Club member.",
    submit: "Refer Now",
    tnc: "利用規約"
  },
  transactionDetails: {
    transaction_date: "お取引日",
    outlet: "アウトレット",
    receipt_no: "領収書番号",
    amount_spend: "合計支払額",
    amount_qualified_for_i_dollar: "i-ドルに変換可能な額",
    i_dollars: "i-ドル",
    selected_start_date: "選択した開始日",
    selected_end_date: "選択した終了日",
    no_tranMsg: "選択した期間中にお取引記録はありません。",
    action: "アクショ",
    apply: "適用する",
    view: "表示する",
  },
  contactUs: {
    title: "お問い合わせ",
    title_message: "以下にフィードバックを記入して送信してください。3〜5営業日以内にご連絡いたします。",
    firstname: "名",
    firstname_errMsg: "名を記入してください",
    lastname: "姓",
    lastname_errMsg: "姓を記入してください",
    emailAddress: "Eメールアドレス",
    emailAddress_errMsg: "有効なEメールアドレスを入力してください",
    mobile: "携帯電話番号",
    mobile_errMsg: "有効な携帯電話番号を入力してください",
    type: "種類",
    type_opt1: "フィードバックメッセージの種類を入力してください:",
    type_opt2: "オプション",
    type_opt3: "問い合わせ",
    type_opt4: "フィードバック",
    type_opt5: "ニュースレターの購読",
    type_errMsg: "フィードバックメッセージの種類を入力してください",
    message: "メッセージ",
    message_errMsg: "フィードバックメッセージを入力してください",
    captcha: "キャプチャ",
    captcha_errMsg: "Captchaが不正ですt",
    feedback_sucMsg: "ご連絡および貴重なフィードバックをいただき誠にありがとうございます。\nお返事までの間、少々お待ちください。",
    submit: "送信",
  },
  mobileApp: {
    title: "IMPERIAL TREASURE MOBILE APP",
    desc_1: "Earn Rewards as You Dine",
    desc_2: "Download Imperial Treasure Mobile App Now!"
  },
  languageSetting: {
    title: "言語設定",
    setting: "ご希望の言語",
    language_preference: "ご希望の言語",
    language_preference_opt1: "ご希望の言語を選択してください",
    language_preference_opt2: "English",
    language_preference_opt3: "日本語",
    language_preference_opt4: "中文",
    language_preference_errMsg: "ご希望の言語を選択してください",
    submit: "送信",
  },
  captcha: {
    title: "セキュリティチェック",
    intro: "認証画像（大文字・小文字を区別）を入力してください。",
    error: "認証画像が正しくありません。",
    confirm: "確認"
  },
  otp: {
    sec: "秒",
    verification_code: "認証コード",
    send_code: "コードを取得",
    resend_code: "コードを再送信",
    success_sent_mobile: "登録されている携帯電話番号に認証コードを送信しました。",
    success_sent_email: "登録されているメールアドレスに認証コードを送信しました。",
    err_login: "「コードを取得」ボタンを選択して、認証コードを取得してください。",
    err_verify: "入力された認証コードが正しくありません。送信された6桁のコードを再度入力してください。",
    err_expired: "認証コードの有効期限が切れています。新しいコードを取得してください。",
    incorrect_mobile: "入力された携帯電話番号が正しくありません。",
    incorrect_email: "入力されたメールアドレスが正しくありません。",
    please_retry: "3分後にもう一度コードリクエストしてください。"
  }
};